import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const getPartiesList = ({ name } = {}) =>
  axios.post(
    `${constants.apiHost}/parties/list`,
    { name },
    {
      headers: headersProvider(),
    },
  );

export const addParty = ({ partyData }) =>
  axios.post(`${constants.apiHost}/parties/add`, partyData, {
    headers: headersProvider(),
  });

export const updateParty = ({ partyData }) =>
  axios.put(`${constants.apiHost}/parties/update/${partyData.id}`, partyData, {
    headers: headersProvider(),
  });

export const deleteParty = ({ id }) =>
  axios.delete(`${constants.apiHost}/parties/delete/${id}`, {
    headers: headersProvider(),
  });

// export const getPartyNames = ()=>{
//   axios.get(`${constants.apiHost}/parties/partynames`,{
//     headers: headersProvider(),
//   })
// }
export const getPartyNames = () =>
  axios.get(`${constants.apiHost}/parties/partynames`, {
    headers: headersProvider(),
  });
// export const getWorkSpaceLists = () =>
//   axios.post(`${constants.apiHost}/parties/list`,
//   {
//     headers: headersProvider(),
//   });
